var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"deck-box"},[_c('DeckList',{attrs:{"decks":_vm.publicDecks,"linkType":'a',"linkTarget":'_parent'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }